export default __webpack_public_path__ + "static/media/CULTURE_CELLULAIRE.bd499038.jpg";